import React, { useEffect, useState } from 'react';
import Navbar from '../navbar/navbar';
import FooterBar from '../footer/footerBar';
import customizeScrollbar from 'customsb';
import api from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import SweetAlert from 'react-bootstrap-sweetalert';
import './configGerencial.css'

function ConfigGerencial (){


  const [busca,setBusca] = useState("");
  const [caixas,setCaixas] = useState([]);
  const [sResult,setSresult] = useState('N');

  let config = {
     headers: {
       'Authorization': localStorage.getItem("token")
     }
   }

   let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }

   const inputs = document.querySelectorAll("input, select, NumericFormat ,button ");
   // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
   inputs.forEach(input => {
     input.addEventListener("keydown", e => {
       // Se a tecla pressionada for Enter
       if (e.key === "Enter") {
         e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

         if (e.target.tagName.toLowerCase() === "button") {
           e.target.click(); // Dispara o evento de clique do botão
         } else {
         // Obtenha o índice do elemento atual
         const currentIndex = Array.from(inputs).indexOf(e.target);
 
         // Mova o foco para o próximo elemento de entrada ou select
         const nextIndex = currentIndex + 1;
         if (nextIndex < inputs.length) {
           inputs[nextIndex].focus();
         }
       }
     }
     });
   });


  useEffect(function(){
 
     api.post(vhostV1('webcash/caixa/configcaixa'),{},config)
       .then(function (response) {
         console.log(response);
         
         setCaixas(response.data.dados); 
         setSresult(response.data.result)
         
                                     
                  
       })
       .catch(function (error) {
        
         console.log(error);

                 
       });
 
       
     },[busca])

     

      // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
// O uso do useEffect garante que a função seja chamada apenas no lado do cliente
customizeScrollbar({
 scrollbarWidth: "10px",
 trackBackground: "#333",
 thumbBackground:
   "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
 thumbBorderRadius: "10px",
});
}, []);

    
      const [showModal, setShowModal] = useState(false);
      const [showModal2, setShowModal2] = useState(false);
      const [nome, setNome] = useState('');
      const [ip, setIp] = useState('');
      const [path, setPath] = useState('');
      const [path2, setPath2] = useState('');
      const [cnpj, setCnpj] = useState('');
      const [msgErro, setmsgErro] = useState('');
      const [erroValidacao, setErrovalidacao] = useState(false);
      const [estoques, setEstoques] = useState([]);
      const [imagens, setImagens] = useState([{COD_PRODUTO: 15001, ARQUIVO: '15001.jpeg'}]);
      const [rotaImagem, setRotaImagem] = useState(null);
      const [result, setResult] = useState(0);

      useEffect(function(){
 
        api.get(vhostV1('webcash/estoque/listarEstoques'),config)
          .then(function (response) {
            console.log(response);
            
            setEstoques(response.data.dados); 
            setSresult(response.data.result);
            
                                        
                     
          })
          .catch(function (error) {
           
            console.log(error);
   
                    
          });
    
          
        },[busca])

      useEffect(() => {
        const handleKeyDown = (e) => {
          switch (e.key) {
            case 'F1':
              e.preventDefault();
              setShowModal(true); 
              break;
            case 'F2':
              e.preventDefault();
              salvaConfig(); 
              break;
            case 'Escape':
              if (showModal) {
                e.preventDefault();
                setShowModal(false);
              }
              break;
            default:
              break;
          }
        };
      
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
      }, [showModal]);

      useEffect(function(){

        api.post(vhostV1('webcash/produto/imagem/rota'),{},config)
          .then(function (response) {
            console.log(response);

            if(response.data !== null){
            
            setRotaImagem(response.data); 
            setResult(1);
            }
                                        
                     
          })
          .catch(function (error) {
           
            console.log(error);
   
                    
          });
      },[])

    
     
    
      

      function salvaConfig(){
        
            if(nome.length === 0 ){  
              {setmsgErro("NOME NÃO PODE ESTAR VAZIO");
                  setErrovalidacao(true)}
              return    
          } else if(ip.length === 0){  
            {setmsgErro("IP NÃO PODE ESTAR VAZIO");
                setErrovalidacao(true)}
            return    
        }   else if(path.length === 0){  
          {setmsgErro("ROTA NÃO PODE ESTAR VAZIO");
              setErrovalidacao(true)}
            return
        }    else if(cnpj.length === 0 ){  
          {setmsgErro("CNPJ NÃO PODE ESTAR VAZIO");
              setErrovalidacao(true)}
            return
        } 
          
          else{
                api.post(vhostV1('webcash/estoque/adicionarEstoque'),{
                    nome: nome,
                    ip: ip,
                    path: path,
                    cnpj: cnpj
                   
                },config)
                .then(function(response){
                  setNome('');
                  setIp('');
                  setPath('');
                  setCnpj('');
                    console.log(response);
                    setShowModal(false);
                    window.location.reload();
                                
                }).catch((erro) =>{
                    
                    console.log(erro)
                    setShowModal(false);
                });
        
           } }

           function salvaConfig2(){
        
            if(path2.length > 60 ){  
              {setmsgErro("ROTA NÃO PODE TER MAIS DE 60 CARACTERES");
                  setErrovalidacao(true)}
              return    
          } else if(path2.length === 0){  
          {setmsgErro("ROTA NÃO PODE ESTAR VAZIO");
              setErrovalidacao(true)}
            return
        }    
          
          else{
                api.post(vhostV1('webcash/produto/imagem/atualizar'),{                    
                    path: path2                                       
                },config)
                .then(function(response){
                  
                  setPath2('');
              
                    console.log(response);
                    setShowModal2(false);
                    window.location.reload();
                                
                }).catch((erro) =>{
                    
                    console.log(erro)
                    setShowModal2(false);
                });
        
           } }


    
      return (
        <div>
            <Navbar/>
        <div className="container-fluid titulo offset-lg-1 col-lg-10" id="configurations-page">
          
        <div className="d-flex justify-content-between">
          <h1 className="text-center mb-4">Configurações</h1>
          <button
  className="btn btn-primary btn-cli"
  id="add-config-button"
  onClick={() => setShowModal(true)}
>
  <i className="bi bi-plus-circle-fill"></i>
  Configuração <span className="shortcut">(F1)</span>
</button>
          </div>
    
          <div className="mb-4 mt-5" id="configurations-list">
          <nav>
             <div className="nav nav-tabs" id="nav-tab" role="tablist">
                 <button className="nav-link active" id="nav-estoque-tab" data-bs-toggle="tab" data-bs-target="#nav-estoque" type="button" role="tab" aria-controls="nav-estoque" aria-selected="true" tabIndex="0">ESTOQUE</button>
                 <button className="nav-link" id="nav-pdv-tab" data-bs-toggle="tab" data-bs-target="#nav-pdv" type="button" role="tab" aria-controls="nav-pdv" aria-selected="false" tabIndex="0">PDV</button>
                 {/* <button className="nav-link" id="nav-imagens-tab" data-bs-toggle="tab" data-bs-target="#nav-imagens" type="button" role="tab" aria-controls="nav-imagens" aria-selected="false" tabIndex="0">IMAGENS</button> */}
                 
             </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="nav-estoque" role="tabpanel" aria-labelledby="nav-estoque-tab" tabIndex="0">
            <table  id="table-empresas" className="table table-hover table-striped mb-5">
            <thead>
            <tr>
                
                <th scope="col">NOME</th>
                <th scope="col">IP</th>
                <th scope="col">ROTA</th>
                <th scope="col">CNPJ</th>
                <th scope="col">AÇÃO</th>
                
                
                </tr>
            </thead>
            <tbody className="table-group-divider">
              {  
                 estoques.map((config)=> {
                  return <tr key={config.PATH}>         
                      <td>{config.NOME}</td>          
                      <td>{config.IP}</td>
                      <td>{config.PATH}</td>
                      <td>{config.CNPJ}</td>
                      <td><div className="dropdown">
                      <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true" tabIndex="0">
                          Opções
                       </button>
                       <ul className="dropdown-menu">
                        <li><button className="dropdown-item" ><i className="bi bi-pen-fill"></i>Editar</button></li>
                        <li><button className="dropdown-item" ><i className="bi bi-x-circle-fill"></i>Excluir</button></li>                                                                          
                       </ul>
                        </div>
                        </td>
                      
                  </tr>
              } )}  
            </tbody>
          </table>
            </div>

            <div className="tab-pane fade" id="nav-pdv" role="tabpanel" aria-labelledby="nav-pdv-tab" tabIndex="1">

              
        { sResult === 1?
         <table  id="table-empresas" className="table table-hover table-striped mb-5">
            <thead>
            <tr>
                
                <th scope="col">CAIXA</th>
                <th scope="col">ECF</th>
                <th scope="col">AÇÃO</th>
                
                
                </tr>
            </thead>
            <tbody className="table-group-divider">
            {  
                 caixas.map((caixa)=> {
                  return <tr key={caixa.CAIXA}>         
                      <td>{caixa.CAIXA}</td>          
                      <td>{caixa.ECF}</td>
                      <td><div className="dropdown">
                      <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          Opções
                       </button>
                       <ul className="dropdown-menu">
                        <li><button className="dropdown-item" ><i className="bi bi-pen-fill"></i>Editar</button></li>
                        <li><button className="dropdown-item" ><i className="bi bi-x-circle-fill"></i>Excluir</button></li>                                                                          
                       </ul>
                        </div>
                        </td>
                      
                      
                  </tr>
              } )}  
            </tbody>
          </table>

           :null} 
          
     
    
              </div>

              <div className="tab-pane fade" id="nav-imagens" role="tabpanel" aria-labelledby="nav-imagens-tab" tabIndex="2">

              
        { result === 1?
         <table id="table-empresas" className="table table-hover table-striped mb-5">
         <thead>
           <tr>
             <th scope="col">STATUS</th>
             <th scope="col">PATH</th>
             <th scope="col">AÇÃO</th>
           </tr>
         </thead>
         <tbody className="table-group-divider">
           <tr>
             <td>{rotaImagem.status}</td>
             <td>{rotaImagem.path}</td>
             <td>
               <div className="dropdown">
                 <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                   Opções
                 </button>
                 <ul className="dropdown-menu">
                   <li>
                     <button className="dropdown-item" onClick={() => setShowModal2(true)}>
                       <i className="bi bi-pen-fill" ></i> Editar
                     </button>
                   </li>
                   
                 </ul>
               </div>
             </td>
           </tr>
         </tbody>
       </table>

           :null} 
          
     
    
              </div>
            </div>
          </div>
    
          
    
          {showModal && (
            <div className="modal d-block" id="add-config-modal" tabIndex="-1" aria-modal="true" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title"  id="modal-title">Adicionar Estoque</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                       aria-label="Close"
                       tabIndex="0"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Nome
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        autoFocus
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="ip" className="form-label">
                        IP
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ip"
                        value={ip}
                        onChange={(e) => setIp(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="route" className="form-label">
                        Rota
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="route"
                        value={path}
                        onChange={(e)=> setPath(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="cnpj" className="form-label">
                        CNPJ
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="cnpj"
                        value={cnpj}
                        onChange={(e) => setCnpj(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Fechar
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={salvaConfig}
                    >
                      Adicionar(F2)
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showModal2 && (
            <div className="modal d-block" id="add-config-modal" tabIndex="-1" aria-modal="true" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title"  id="modal-title">Alterar Diretório de Imagens</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal2(false)}
                       aria-label="Close"
                       tabIndex="0"
                    ></button>
                  </div>
                  <div className="modal-body">
                    
                    
                    <div className="mb-3">
                      <label htmlFor="route" className="form-label">
                        Rota
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="route"
                        value={path2}
                        onChange={(e)=> setPath2(e.target.value)}
                      />
                    </div>
                    
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal2(false)}
                    >
                      Fechar
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={salvaConfig2}
                    >
                      Adicionar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {
                     erroValidacao ? 
                     <SweetAlert
                        danger
                        confirmBtnText="OK"
                        confirmBtnBsStyle="danger"
                        title="Erro"
                        onConfirm={() => setErrovalidacao(false)}                            
                      >
                        {msgErro}
                      </SweetAlert>:null
                     
                    }
        </div>
        <FooterBar/>
        </div>
      );
    }


export default ConfigGerencial